<template>
  <div class="mainview">
    <block v-if="thumb != null">
      <div class="hedImageView">
        <div v-if="request_typ == 1">
          <div
            v-if="request_typTX == 1"
            class="deleXImageV"
            @click="didDelImg(0)"
          >
            <img class="deleXImage" src="../assets/img/desel.png" />
          </div>
        </div>

        <img
          @click="didUpdataImg()"
          class="hedImage"
          :src="thumb"
          style="width: 100%; height: 100%"
        />
      </div>
    </block>
    <block v-if="thumb == null">
      <div class="hedImageView" @click="didUpdataImg()">
        <img
          v-if="gender == 0"
          class="hedImage"
          src="../assets/img/icon_default_man.png"
          style="width: 100%; height: 100%"
        />
        <img
          v-if="gender == 1"
          class="hedImage"
          src="../assets/img/icon_default_woman.png"
          style="width: 100%; height: 100%"
        />
      </div>
    </block>

    <input
      id="file"
      type="file"
      accept="image/png,image/gif,image/jpeg"
      @change="update"
    />

    <div class="listViewh">
      <div class="cellView-l">
        <div class="tite_view">姓名：</div>
        <div class="sectionViewl">
          <input
            class="inputViewl"
            bindinput="didinputName"
            v-model="username"
            placeholder="请输入姓名"
            type="text"
          />
        </div>
      </div>
      <div class="cellView-l">
        <div class="tite_view">字辈：</div>
        <div class="sectionViewl">
          <input
            class="inputViewr"
            bindinput="didinputZiBei"
            v-model="zb"
            placeholder="族中字辈"
            type="text"
          />
        </div>
      </div>
    </div>

    <div class="listViewh">
      <div class="cellView-l">
        <div class="tite_view">小名：</div>
        <div class="sectionViewl">
          <input
            class="inputViewr"
            bindinput="didinputNikName"
            v-model="nickname"
            placeholder="别称、小名"
            type="text"
          />
        </div>
      </div>

      <div class="cellView-l">
        <div class="tite_view">排行：</div>
        <div class="sectionViewl">
          <select v-model="ranking">
            <option
              v-for="(option, index) in rArray"
              v-bind:value="option"
              :key="index"
            >
              {{ option }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="listViewh">
      <div class="cellView-l">
        <div class="tite_view">性别：</div>
        <div class="sectionViewl">
          <input
            type="radio"
            checked="checked"
            name="radios"
            value="0"
            v-model="gender"
          />男<input type="radio" name="radios" value="1" v-model="gender" />女
        </div>
      </div>
      <div class="cellView-l">
        <div class="tite_view">生肖：</div>
        <div class="sectionViewl">
          <select v-model="anSign">
            <option
              v-for="(option, index) in anArray"
              v-bind:value="option"
              :key="index"
            >
              {{ option }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="listView">
      <div class="tite_view">生日：</div>
      <div class="sectionView" v-if="isBir == '1'">
        <div class="sectionViewS">
          <input
            class="inputViewlp"
            v-model="birthday"
            placeholder-class="phcolor"
            placeholder="请选择出生日期"
            type="date"
          />
          <div v-if="nlbirthday">{{ nlbirthday }}</div>
        </div>
      </div>
      <div class="sectionView" v-if="isBir == '2'">
        <input
          class="inputView"
          placeholder-class="phcolor"
          v-model="birthday"
          placeholder="请输入出生日期"
        />
      </div>
      <img
        class="qiehuan"
        src="../assets/img/qiehuan.svg"
        @click="didBirdayQieHuan()"
      />
    </div>

    <div class="listView">
      <div class="tite_view">现居：</div>

      <div class="sectionView" v-if="isSd == '2'">
        <VDistpicker class="dispicker" @selected="proviceAddress"></VDistpicker>
      </div>
      <div class="sectionView" v-if="isSd == '1'">
        <input
          class="inputView"
          placeholder-class="phcolor"
          bindinput="didinputRegion"
          v-model="address"
          placeholder="请输入现居地址"
          type="text"
        />
      </div>
      <!-- <img
        class="qiehuan"
        src="../assets/img/qiehuan.svg"
        bindtap="didArrQieHuan"
      /> -->
    </div>

    <div class="listView">
      <div class="tite_view">电话：</div>
      <div class="sectionView">
        <input
          class="inputView"
          placeholder-class="phcolor"
          bindinput="didtelPhone"
          v-model="telPhone"
          placeholder="请输入联系电话"
          type="number"
          maxlength="11"
        />
      </div>
    </div>

    <div v-if="request_typ == 1">
      <div class="missing-but" @click="didsaveButt()">保存信息</div>

      <div class="missing-butdel" @click="diddeleteButt()" v-if="deleShow">
        删除信息
      </div>
    </div>

    <div v-if="request_typ == 0" class="missing-XD" @click="didsavXD()">
      修订
    </div>

    <DialogView ref="myDialog" @userBehavior="changeData"></DialogView>

    <!-- 弹框 -->
    <tank v-if="password_show" @childFn="parentFn"></tank>
  </div>
</template>

<script>
import VDistpicker from "v-distpicker";

import DialogView from "./DialogView.vue";
import Tank from "./TanK.vue";

export default {
  name: "addFamily",
  components: { VDistpicker, DialogView, Tank },

  data() {
    return {
      isAD: true,
      isBir: "1",
      isSd: "1",
      rArray: [
        "未知",
        "老大",
        "老二",
        "老三",
        "老四",
        "老五",
        "老六",
        "老七",
        "老八",
        "老九",
        "老十",
        "老十一",
        "老十二",
      ],
      anArray: [
        "未知",
        "子鼠",
        "丑牛",
        "寅虎",
        "卯兔",
        "辰龙",
        "巳蛇",
        "午马",
        "未羊",
        "申猴",
        "酉鸡",
        "戌狗",
        "亥猪",
      ],
      dataSource: null,

      type: null,

      imageSrc: "",

      nameid: null,
      thumb: null,
      gender: 0,
      username: null,
      telPhone: null,
      birthday: null,
      ranking: null,
      address: "",
      anSign: null,
      nickname: null,
      zb: null,

      userDic: null,

      deleShow: false,

      nlbirthday: null,
      windowWidth: 750,

      pssword_is: false,
      password_show: false,
      request_typ: 0, //1 保存 2 删除  3删除图片
      request_typTX: 1,
    };
  },

  methods: {
    //获取数据
    getReaDataAll: function () {
      var that = this;
      let password = localStorage.getItem("passwodr");
      var prem = {
        pass_wode: password,
      };
      this.axios
        .post(this.COMMON.httpUrl + "go_home/readata", prem)
        .then((res) => {
          if (res.data.code == 1) {
            var familyJson = res.data.data.familyJson;
            if (familyJson) {
              var familyJsonStr = this.COMMON.decode(familyJson);
              var obj = JSON.parse(familyJsonStr);
              that.dataSource = obj;
            }
          } else if (res.data.code == 2) {
            that.$router.push({ name: "homeBook" });
          }
        });
    },
    //切换生日输入
    didBirdayQieHuan: function () {
      var isBir = this.isBir;
      if (isBir == "1") {
        this.isBir = "2";
      } else {
        this.isBir = "1";
      }
    },

    //输入的生日
    didinputBirday: function (e) {
      this.setData({
        birthday: e.detail.value,
      });
    },
    //将选择的数据获取过来进行操作
    proviceAddress(data) {
      console.log(data);
    },

    //点击上传头像
    didUpdataImg() {
      document.querySelector("#file").click();
    },
    update(e) {
      if (this.thumb &&  this.request_typTX == 1) {
        this.didDelImg(1);
      }

      // 上传照片
      let self = this;
      let file = e.target.files[0];
      /* eslint-disable no-undef */
      let param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      param.append("image_name", "0"); // 添加form表单中其他数据
      // 添加请求头
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      axios
        .post(this.COMMON.httpUrl + "go_home/upimg", param, config)
        .then((res) => {
          if (res.data.code == 1) {
            self.thumb = this.COMMON.httpUrl + res.data.filename;
            this.request_typTX = 1;
          }
          document.getElementById("file").value = null;
        });
    },

    //删除图片
    didDelImg(token) {
      let that = this;
      var imagename = this.thumb.replace(this.COMMON.httpUrl, "");
      let password = localStorage.getItem("passwodr");
      let tokencode = localStorage.getItem("passwodrEit");
      var prem = {
        pass_wode: password,
        token_code: tokencode,
        image_name: imagename,
      };
      axios.post(this.COMMON.httpUrl + "go_home/deleimg", prem).then((res) => {
        if (res.data.code == 1) {
          if (token != 1) {
            that.thumb = null;
          }
        } 
      });
    },

    //点击保存
    didsaveButt() {
      var isBind = 0;
      var thumb = this.thumb;
      var username = this.username;
      var userDic = this.userDic;

      if (username == null || username == "") {
        alert("请输入姓名");
        return;
      }

      var type = this.type;
      if (thumb) {
        isBind = 1;
      }

      var nameidx = new Date().getTime();
      if (userDic && userDic.nameid) {
        nameidx = userDic.nameid;
      }
      var childrendic = {
        nameid: nameidx,
        isBind: isBind,
        is_wife: "0",
        thumb: thumb,
        username: username,
        zb: this.zb,
        gender: this.gender,
        ranking: this.ranking,
        birthday: this.birthday,
        telPhone: this.telPhone,
        address: this.address,
        anSign: this.anSign,
        nickname: this.nickname,
      };
      if (type == "new") {
        this.addUpdata(childrendic);
      } else if (type == "daughter") {
        this.addchildren(childrendic);
      } else if (type == "son") {
        this.addchildren(childrendic);
      } else if (type == "user") {
        this.editoUser(childrendic);
      } else if (type == "wife") {
        this.addeditoWife(childrendic);
      } else if (type == "husband") {
        this.addeditoWife(childrendic);
      } else if (type == "brother") {
        this.addchildren(childrendic);
      } else if (type == "sister") {
        this.addchildren(childrendic);
      } else if (type == "mother") {
        this.addparents(childrendic);
      } else if (type == "father") {
        this.addparents(childrendic);
      }
    },

    //添加儿女 兄妹
    addchildren: function (childrendic) {
      var nameid = this.nameid;
      var treeData = this.dataSource;
      var pass = true;
      var phArray = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      each(treeData, nameid);

      function each(data, nameid) {
        if (data.nameid == nameid) {
          addchildren(data);
          return;
        } else if (data.wife && data.wife.nameid == nameid) {
          addchildren(data);
          return;
        } else if (data.children && data.children.length > 0) {
          for (var i = 0; i < data.children.length; i++) {
            var dic = data.children[i];
            if (dic.nameid == nameid) {
              addchildren(dic);
              return;
            } else if (dic.wife && dic.wife.nameid == nameid) {
              addchildren(dic);
              return;
            } else if (dic.children && dic.children.length > 0) {
              each(dic, nameid);
            }
          }
        }
      }

      function addchildren(data) {
        if (data.children) {
          if (childrendic.ranking) {
            for (var i = 0; i < data.children.length; i++) {
              var cd = data.children[i];
              if (cd.ranking == childrendic.ranking) {
                alert("家中已存在该排行");
                pass = false;
                return;
              }
              addpaihang(cd);
            }
            addpaihang(childrendic);

            var chArray = new Array();
            for (var j = 0; j < phArray.length; j++) {
              var item = phArray[j];
              if (item != 0) {
                chArray.push(item);
              }
            }
            data.children = chArray;
          } else {
            data.children.push(childrendic);
          }
        } else {
          var newchildren = new Array();
          newchildren.push(childrendic);
          data.children = newchildren;
        }
      }

      function addpaihang(cd) {
        if (cd.ranking == "老大") {
          phArray.splice(0, 1, cd);
        } else if (cd.ranking == "老二") {
          phArray.splice(1, 1, cd);
        } else if (cd.ranking == "老三") {
          phArray.splice(2, 1, cd);
        } else if (cd.ranking == "老四") {
          phArray.splice(3, 1, cd);
        } else if (cd.ranking == "老五") {
          phArray.splice(4, 1, cd);
        } else if (cd.ranking == "老六") {
          phArray.splice(5, 1, cd);
        } else if (cd.ranking == "老七") {
          phArray.splice(6, 1, cd);
        } else if (cd.ranking == "老八") {
          phArray.splice(7, 1, cd);
        } else if (cd.ranking == "老九") {
          phArray.splice(8, 1, cd);
        } else if (cd.ranking == "老十") {
          phArray.splice(9, 1, cd);
        } else if (cd.ranking == "老十一") {
          phArray.splice(10, 1, cd);
        } else if (cd.ranking == "老十二") {
          phArray.splice(11, 1, cd);
        } else {
          phArray.push(cd);
        }
      }

      if (pass) {
        this.addUpdata(treeData);
      }
    },

    //修改信息
    editoUser: function (childrendic) {
      var nameid = this.nameid;
      var treeData = this.dataSource;
      var pass = true;
      var phArray = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      each(treeData);

      function each(data) {
        if (data.nameid == nameid) {
          editor(data);
          return;
        } else if (data.wife && data.wife.nameid == nameid) {
          editor(data.wife);
          return;
        } else if (data.children && data.children.length > 0) {
          for (var i = 0; i < data.children.length; i++) {
            var dic = data.children[i];
            if (dic.nameid == nameid) {
              editor(dic);
              addchildren(data);
              return;
            } else if (dic.wife && dic.wife.nameid == nameid) {
              editor(dic.wife);
              return;
            } else if (dic.children && dic.children.length > 0) {
              each(dic);
            }
          }
        }
      }

      function editor(data) {
        data.username = childrendic.username;
        data.thumb = childrendic.thumb;
        data.gender = childrendic.gender;
        data.isBind = childrendic.isBind;
        data.telPhone = childrendic.telPhone;
        data.birthday = childrendic.birthday;
        data.ranking = childrendic.ranking;
        data.address = childrendic.address;
        data.anSign = childrendic.anSign;
        data.nickname = childrendic.nickname;
        data.zb = childrendic.zb;
      }

      function addchildren(dataf) {
        if (dataf.children.length > 1 && childrendic.ranking) {
          for (var i = 0; i < dataf.children.length; i++) {
            var cd = dataf.children[i];
            if (
              childrendic.nameid != cd.nameid &&
              cd.ranking == childrendic.ranking
            ) {
              alert("家中已存在该排行");
              pass = false;
              return;
            }
            addpaihang(cd);
          }

          var chArray = new Array();
          for (var j = 0; j < phArray.length; j++) {
            var item = phArray[j];
            if (item != 0) {
              chArray.push(item);
            }
          }
          dataf.children = chArray;
        }
      }

      function addpaihang(cd) {
        if (cd.ranking == "老大") {
          phArray.splice(0, 1, cd);
        } else if (cd.ranking == "老二") {
          phArray.splice(1, 1, cd);
        } else if (cd.ranking == "老三") {
          phArray.splice(2, 1, cd);
        } else if (cd.ranking == "老四") {
          phArray.splice(3, 1, cd);
        } else if (cd.ranking == "老五") {
          phArray.splice(4, 1, cd);
        } else if (cd.ranking == "老六") {
          phArray.splice(5, 1, cd);
        } else if (cd.ranking == "老七") {
          phArray.splice(6, 1, cd);
        } else if (cd.ranking == "老八") {
          phArray.splice(7, 1, cd);
        } else if (cd.ranking == "老九") {
          phArray.splice(8, 1, cd);
        } else if (cd.ranking == "老十") {
          phArray.splice(9, 1, cd);
        } else if (cd.ranking == "老十一") {
          phArray.splice(10, 1, cd);
        } else if (cd.ranking == "老十二") {
          phArray.splice(11, 1, cd);
        } else {
          phArray.push(cd);
        }
      }

      if (pass) {
        this.addUpdata(treeData);
      }
    },

    //修改伴侣
    addeditoWife: function (wifedic) {
      var treeData = this.dataSource;
      var nameid = this.nameid;
      each(treeData, nameid);
      function each(data, nameid) {
        if (data.nameid == nameid) {
          editoWife(data);
          return;
        } else if (data.children && data.children.length > 0) {
          for (var i = 0; i < data.children.length; i++) {
            var dic = data.children[i];
            if (dic.nameid == nameid) {
              editoWife(dic);
              return;
            } else if (dic.children && dic.children.length > 0) {
              each(dic, nameid);
            }
          }
        }
      }

      function editoWife(data) {
        wifedic.is_wife = "1";
        data.wife = wifedic;
      }

      this.addUpdata(treeData);
    },
    //添加父母
    addparents: function (parents) {
      var treeData = this.dataSource;
      var parentsData = parents;
      var newchildren = new Array();
      newchildren.push(treeData);
      parentsData.children = newchildren;

      this.addUpdata(parentsData);
    },

    //删除信息
    diddeleteButt() {
      //提示框
      this.$refs.myDialog.show("删除后将不可恢复,确认删除吗？", {
        type: "confirm",
        confirmText: "确认",
        cancelText: "取消",
        titleText: "",
      });
    },

    changeData(type) {
      if (type == "clickConfirm") {
        this.diddeleteButtX();
      }
    },

    diddeleteButtX: function () {
      // this.deleteImage();
      var treeData = this.dataSource;
      var nameid = this.nameid;
      var type = this.type;
      each(treeData, nameid);

      function each(data, nameid) {
        if (data.nameid == nameid) {
          if (type == "wife") {
            data.wife = null;
          } else if (type == "husband") {
            data.wife = null;
          } else if (type == "user") {
            treeData = null;
          }
          return;
        }
        if (data.wife && data.wife.nameid == nameid) {
          if (type == "user") {
            data.wife = null;
          }
          return;
        } else if (data.children && data.children.length > 0) {
          for (var i = 0; i < data.children.length; i++) {
            var dic = data.children[i];
            if (dic.nameid == nameid) {
              if (type == "wife") {
                dic.wife = null;
              } else if (type == "husband") {
                dic.wife = null;
              } else if (type == "user") {
                var delsArr = data.children;
                delsArr.splice(i, 1);
              }
              return;
            } else if (dic.wife && dic.wife.nameid == nameid) {
              if (type == "user") {
                dic.wife = null;
              }
              return;
            } else if (dic.children && dic.children.length > 0) {
              each(dic, nameid);
            }
          }
        }
      }

      this.addUpdata(treeData);
    },

    //保存信息
    addUpdata: function (childrendic) {
      let that = this;
      var familyJson = JSON.stringify(childrendic);
      var familyJsonBase = this.COMMON.encode(familyJson);
      let password = localStorage.getItem("passwodr");
      let tokencode = localStorage.getItem("passwodrEit");
      var prem = {
        pass_wode: password,
        token_code: tokencode,
        family_json: familyJsonBase,
      };
      this.axios
        .post(this.COMMON.httpUrl + "go_home/addupdata", prem)
        .then((res) => {
          if (res.data.code == 1) {
            that.$router.go(-1);
          } else if (res.data.code == 2) {
            alert("密码错误,请重新登录");
          }
        });
    },

    //修订查询
    didsavXD: function () {
      this.password_show = true;
    },

    //监听弹框点击事件
    parentFn(payload) {
      console.log(payload);
      this.password_show = false;
      if (payload == "OK") {
        this.request_typ = 1;
      }
    },
  },

  mounted: function () {
    var options = this.$route.params;
    var type = this.$route.params.type;

    if (options.type == "new") {
      this.type = type;
    } else if (type == "son") {
      this.type = type;
      this.gender = 0;
      this.nameid = this.$route.params.nameid;
    } else if (type == "daughter") {
      this.type = type;
      this.gender = 1;
      this.nameid = this.$route.params.nameid;
    } else if (options.type == "brother") {
      let dic = JSON.parse(this.$route.params.dicjson);
      this.type = type;
      this.gender = 0;
      this.nameid = dic.nameid;
    } else if (options.type == "sister") {
      let dic = JSON.parse(this.$route.params.dicjson);
      this.type = type;
      this.gender = 1;
      this.nameid = dic.nameid;
    } else if (options.type == "user") {
      let dic = JSON.parse(options.dicjson);
      this.type = options.type;
      this.nameid = dic.nameid;
      this.thumb = dic.thumb;
      this.gender = dic.gender;
      this.username = dic.username;
      this.zb = dic.zb;
      this.telPhone = dic.telPhone;
      this.birthday = dic.birthday;
      this.ranking = dic.ranking;
      this.address = dic.address;
      this.anSign = dic.anSign;
      this.nickname = dic.nickname;
      this.userDic = dic;
      this.deleShow = true;
    } else if (options.type == "wife") {
      let dic = JSON.parse(options.dicjson);
      if (dic.wife) {
        this.type = options.type;
        this.nameid = dic.nameid;
        this.thumb = dic.wife.thumb;
        this.gender = 1;
        this.username = dic.wife.username;
        this.zb = dic.wife.zb;
        this.telPhone = dic.wife.telPhone;
        this.birthday = dic.wife.birthday;
        this.ranking = dic.wife.ranking;
        this.address = dic.wife.address;
        this.anSign = dic.wife.anSign;
        this.nickname = dic.wife.nickname;
        this.userDic = dic.wife;
        this.deleShow = true;
      } else {
        this.type = options.type;
        this.gender = 1;
        this.nameid = dic.nameid;
      }
    } else if (options.type == "husband") {
      let dic = JSON.parse(this.$route.params.dicjson);
      if (dic.wife) {
        this.type = options.type;
        this.nameid = dic.nameid;
        this.thumb = dic.wife.thumb;
        this.gender = 0;
        this.username = dic.wife.username;
        this.zb = dic.wife.zb;
        this.telPhone = dic.wife.telPhone;
        this.birthday = dic.wife.birthday;
        this.ranking = dic.wife.ranking;
        this.address = dic.wife.address;
        this.anSign = dic.wife.anSign;
        this.nickname = dic.wife.nickname;
        this.userDic = dic.wife;
        this.deleShow = true;
      } else {
        this.type = options.type;
        this.gender = 0;
        this.nameid = dic.nameid;
      }
    } else if (options.type == "mother") {
      this.type = options.type;
      this.gender = 1;
    } else if (options.type == "father") {
      this.type = options.type;
      this.gender = 0;
    }

    //是否包含小程序头像
    if (this.thumb && this.thumb.indexOf("zhangminglingzs") != -1) {
      this.request_typTX = 0;

    }
  console.log("passwodrEit");
    var passwodrEit = localStorage.getItem("passwodrEit");
    console.log(passwodrEit);
    if (passwodrEit && passwodrEit != 0) {
      this.request_typ = 1;
    }

    this.getReaDataAll();
  },
};
</script>

<style scoped>
.mainview {
  width: 100%;
  padding-bottom: 15px;
}
.hedImageView {
  padding-top: 20px;
  padding-bottom: 15px;
  width: 250px;
  height: 250px;
  margin: 0 auto;
}
.hedImage {
  border-radius: 5px;
}
.deleXImageV {
  width: 260px;
  position: absolute;
  margin-top: -15px;
  text-align: right;
}
.deleXImage {
  width: 30px;
  height: 30px;
}
.radio-group {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.radio {
  margin-right: 15px;
}
.listView {
  width: 90%;
  height: 50px;
  margin-left: 5%;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid rgb(241, 241, 241);
  font-size: 14px;
}

.listViewh {
  width: 95%;
  height: 50px;
  margin-left: 5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgb(241, 241, 241);
  font-size: 14px;
}

.tite_view {
  font-size: 14px;
  color: #666;
}

.sectionView {
  width: 250px;
  color: #666;
  margin-left: 5px;
  font-family: "Microsoft YaHei";
}
.sectionViewl {
  margin-left: 5px;
  color: #666;
  font-family: "Microsoft YaHei";
}
.inputViewl {
  width: 125px;
}
.inputViewr {
  width: 85px;
}

.inputViewlS {
  width: 90px;
}

.sectionView3 {
  width: 70%;
  color: #666;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  word-break: break-all;
}

.inputView {
  word-break: break-all;
  font-family: "Microsoft YaHei";
  color: #444;
  font-size: 15px;
}
.inputViewS {
  word-break: break-all;
  font-family: "Microsoft YaHei";
  color: #444;
  font-size: 14px;
}

.phcolor {
  color: #c0c0c0;
  font-size: 13px;
}
.picker {
  word-break: break-all;
  font-family: "Microsoft YaHei";
  color: #444;
  font-size: 15px;
}
.picker1 {
  word-break: break-all;
  font-family: "Microsoft YaHei";
  color: #c0c0c0;
  font-size: 15px;
}

.listView1 {
  width: 92%;
  height: 65px;
  margin-left: 5%;
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  align-items: center;
  border-bottom: 1px solid rgb(241, 241, 241);
}

.lestView {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.cellView-l {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.sectionView1 {
  width: 225px;
  color: #666;
  margin-left: 10px;
  font-family: "Microsoft YaHei";
}
.sectionViewS {
  color: #666;
  margin-left: 5px;
  font-family: "Microsoft YaHei";
  display: flex;
  flex-direction: row;
  align-items: center;
}
/* .inputViewlp{
  width: 200px;
} */

.harAdd {
  padding-top: 12px;
  display: flex;
  flex-direction: row;
}

.textareaView_dz {
  font-family: "Microsoft YaHei";
  width: 75px;
  height: 50px;
  line-height: 25px;
}

.textareaView {
  font-family: "Microsoft YaHei";
  width: 200px;
  height: 50px;
  margin-left: 5px;
  color: #666;
  line-height: 25px;
}

.imageView {
  width: 30px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.missing-but {
  width: 94%;
  margin-left: 3%;
  margin-top: 40px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  background-color: #0c3874;
  color: #fff;
  border-radius: 3px;
}

.missing-butdel {
  width: 94%;
  margin-left: 3%;
  margin-top: 20px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  background-color: red;
  color: #fff;
  border-radius: 3px;
}

.missing-XD {
  width: 94%;
  margin-left: 3%;
  margin-top: 20px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  background-color: burlywood;
  color: #fff;
  border-radius: 3px;
}

.picker {
  width: 250px;
  height: 50px;
  line-height: 50px;
}

.qiehuan {
  width: 40px;
  height: 40px;
}

/* 默认压缩组件不显示 */
.press-canvas {
  position: absolute;
  top: -1000px;
  background-color: gray;
}

.dispicker {
  widows: 100px;
  height: 25px;
}

.addimge {
  background: red;
  padding-top: 20px;
  padding-bottom: 15px;
  width: 250px;
  height: 250px;
  margin: 0 auto;
  outline-style: none;
  border: 0px;
}

#file {
  display: none;
}
</style>